import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTicket: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTicket"><Path d="M21.5 4.5H2.5V9.5C3.88071 9.5 5 10.6193 5 12C5 13.3807 3.88071 14.5 2.5 14.5V19.5H21.5V14.5C20.1193 14.5 19 13.3807 19 12C19 10.6193 20.1193 9.5 21.5 9.5V4.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 7.5V8.5" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 11.5V12.5" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 15.5V16.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconTicket;
